// Generated by scripts/build-icons.js from the installed Font Awesome icon packs.
// Do not edit by hand.
import type { FaIcon } from 'shared/components/icon';

export const falSearch = {"name":"search","type":"fal","definition":[512,512,"magnifying-glass","M384 208a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]} as const satisfies FaIcon;
